import styled from '@emotion/styled';
import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { useGetOne } from 'react-admin';
import { getChainId } from '../../../lib';
import frameIphone from '../../../assets/images/frame-iphone-14.png';
import { FaRegUser } from "react-icons/fa";
import { MdOutlineCardGiftcard, MdOutlineHome, MdOutlineLocalGasStation } from "react-icons/md";
import { PiGasCan } from 'react-icons/pi';

export const WIDTH = 292;
export const HEIGHT = 590;

// Componentes base reutilizáveis
export const FlexColumn = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const FlexCentered = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const MobileContainer = styled('div')({
  width: WIDTH - 40,
  height: HEIGHT - 90,
  backgroundColor: 'white',
  margin: '60px 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 10,
});

export const MobileFrame = styled('img')({
  position: 'absolute',
  width: WIDTH,
  height: HEIGHT,
  top: -60,
});

// BottomBar Components
export const BottomBarContainer = styled('div')({
  position: 'absolute',
  height: 40,
  backgroundColor: 'white',
  width: WIDTH - 15,
  bottom: 5,
  boxShadow: '-1px -1px 5px -1px rgba(82,82,82,0.61)',
  padding: '5px 20px',
  display: 'flex',
  justifyContent: 'space-between'
});

export const BottomBarItem = styled(FlexColumn)({
  alignItems: 'center',
  justifyContent: 'center',
});

export const BottomBarLabel = styled(Typography)({
  fontSize: '8px',
});

export const BottomBarCircleButton = styled(FlexCentered)<{ color: string }>(({ color }) => ({
  minHeight: 40,
  width: 40,
  borderRadius: '50%',
  backgroundColor: color,
  marginBottom: 5,
  marginTop: -25,
}));

// BottomBar Component
export const BottomBar: React.FC<{ color: string }> = ({ color }) => (
  <BottomBarContainer>
    <BottomBarItem>
      <MdOutlineHome fontSize={18} />
      <BottomBarLabel>Início</BottomBarLabel>
    </BottomBarItem>
    <BottomBarItem>
      <MdOutlineCardGiftcard fontSize={18} />
      <BottomBarLabel>Resgatar</BottomBarLabel>
    </BottomBarItem>
    <BottomBarItem>
      <BottomBarCircleButton color={color}>
        <PiGasCan fontSize={18} color="white" />
      </BottomBarCircleButton>
      <BottomBarLabel>Abastecer</BottomBarLabel>
    </BottomBarItem>
    <BottomBarItem>
      <MdOutlineLocalGasStation fontSize={18} />
      <BottomBarLabel>Postos</BottomBarLabel>
    </BottomBarItem>
    <BottomBarItem>
      <FaRegUser fontSize={15} />
      <BottomBarLabel>Perfil</BottomBarLabel>
    </BottomBarItem>
  </BottomBarContainer>
);

// Base Mobile Wrapper Component
interface MobileWrapperProps {
  data: any;
  children: (chain: any) => React.ReactNode;
}

const MobileWrapper: React.FC<MobileWrapperProps> = ({ data, children }) => {
  const [chainId] = useState(getChainId());

  if (!chainId) {
    return <Typography>Selecione uma Rede</Typography>;
  }

  const { data: chain } = useGetOne('chains', { id: chainId });

  if (!chain || !chain.appColor) {
    return <></>;
  }

  return (
    <div style={{ position: 'relative', width: WIDTH }}>
      <MobileContainer>
        {children(chain)}
        <BottomBar color={chain.appColor} />
        <MobileFrame style={{ pointerEvents: 'none', zIndex: 9 }} src={frameIphone}  draggable={false} />
      </MobileContainer>
    </div>
  );
};

export default MobileWrapper;